import React from "react";
import { Link, useOutletContext } from "react-router-dom";
// COMPONENTES
import HelmetSEO from "../../componentesEspeciales/helmetSEO";
import { pixelClickDescargaApp } from "../../funcionesDatos/pixelFacebook";
import { gtagClickDescargaApp } from "../../funcionesDatos/pixelGoogle";
import { ttqClickDescargaApp } from "../../funcionesDatos/pixelTiktok";
import { eventoClickDescargaApp } from "../../funcionesDatos/eventoPropio";

const linksPrincipales = [
  {
    titulo: "Descarga iOS",
    descripcion: "Instala Zervicy desde App Store.",
    icono: "bi-apple",
    textoBoton: "Descargar para iPhone",
    url: "https://apps.apple.com/co/app/zervicy/id6761780592",
    externo: true,
    plataforma: "ios",
  },
  {
    titulo: "Descarga Android",
    descripcion: "Instala Zervicy desde Google Play.",
    icono: "bi-google-play",
    textoBoton: "Descargar para Android",
    url: "https://play.google.com/store/apps/details?id=com.zervicy.app",
    externo: true,
    plataforma: "android",
  },
  {
    titulo: "Cómo funciona",
    descripcion: "Aprende cómo ofrecer o contratar servicios en Zervicy.",
    icono: "bi-play-circle",
    textoBoton: "Ver cómo funciona",
    url: "/como-funciona",
    externo: false,
  },
  {
    titulo: "Buscar servicios",
    descripcion: "Explora servicios disponibles y encuentra lo que necesitas.",
    icono: "bi-search",
    textoBoton: "Buscar servicios",
    url: "/",
    externo: false,
  },
  {
    titulo: "Crea tu cuenta",
    descripcion: "Únete a Zervicy para comprar o vender servicios.",
    icono: "bi-person-plus",
    textoBoton: "Crear cuenta",
    url: "/registrar",
    externo: false,
  },
  {
    titulo: "Inicia sesión",
    descripcion: "Entra a tu cuenta para gestionar servicios y reservas.",
    icono: "bi-box-arrow-in-right",
    textoBoton: "Iniciar sesión",
    url: "/iniciar-sesion",
    externo: false,
  },
];

function Links() {
  const { usuario, cargandoUsuario } = useOutletContext() || {};

  return (
    <div>
      <HelmetSEO
        titulo="Links oficiales y descargas | Zervicy"
        descripcion="Descarga la app de Zervicy, accede a nuestras redes sociales y encuentra todos los links oficiales desde un solo lugar."
        imagen="https://zervicy.s3.us-east-1.amazonaws.com/imagenes/marca/links.png"
      />
      <div className="bg-light" style={{ minHeight: "100vh" }}>
        <div className="container py-4 py-md-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10 col-xl-8">
              <div className="text-center mb-4 mb-md-5">
                <span
                  className="badge rounded-pill px-3 py-2 mb-3"
                  style={{
                    backgroundColor: "var(--azul-logo-claro)",
                    color: "white",
                  }}
                >
                  Links oficiales
                </span>

                <h1
                  className="display-6 fw-bold mb-2"
                  style={{ color: "var(--color-text-primary)" }}
                >
                  Zervicy
                </h1>

                <p
                  className="text-muted mb-0 mx-auto"
                  style={{ maxWidth: 720 }}
                >
                  Aquí tienes todos nuestros enlaces oficiales para descargar la
                  app, encontrar servicios y entrar a tu cuenta.
                </p>
              </div>

              <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4">
                <div className="p-4 p-md-5 text-center position-relative" style={{ color: "white" }}>
                  {/* Fondo: imagen */}
                  <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 0 }}>
                    <img
                      src="https://zervicy.s3.us-east-1.amazonaws.com/imagenes/marca/links.png"
                      alt=""
                      className="w-100 h-100"
                      style={{ objectFit: "cover", objectPosition: "center" }}
                    />
                  </div>

                  {/* Overlay azul oscuro (mismo estilo que el hero de Home.jsx) para que el texto resalte */}
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background: "linear-gradient(135deg, rgba(var(--azul-muy-oscuro-rgb), 0.88) 0%, rgba(var(--azul-gradiente-2-rgb), 0.72) 55%, rgba(var(--azul-gradiente-3-rgb), 0.62) 100%)",
                      zIndex: 1,
                    }}
                  />

                  <div className="position-relative" style={{ zIndex: 2 }}>
                    <div
                      className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 76,
                        height: 76,
                        backgroundColor: "rgba(var(--blanco-rgb), .12)",
                        border: "1px solid rgba(var(--blanco-rgb), .18)",
                      }}
                    >
                      <i
                        className="bi bi-lightning-charge-fill fs-1"
                        style={{ color: "var(--naranja-cta)" }}
                      />
                    </div>

                    <h2 className="h3 fw-bold mb-2">
                      Todos los enlaces de Zervicy en un solo lugar
                    </h2>
                    <p className="mb-0 opacity-75">
                      Descarga la app, busca servicios, crea tu cuenta o inicia
                      sesión desde aquí. Todo listo para que entres rápido y sin
                      perder tiempo.
                    </p>
                  </div>
                </div>
              </div>

              <div className="d-grid gap-3">
                {linksPrincipales.map((item) => {
                  const contenido = (
                    <>
                      <span
                        className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                          width: 46,
                          height: 46,
                          backgroundColor: "rgba(var(--azul-logo-claro-rgb), .10)",
                          color: "var(--azul-logo-claro)",
                        }}
                      >
                        <i className={`bi ${item.icono} fs-5`} />
                      </span>

                      <span className="text-start flex-grow-1">
                        <span
                          className="d-block fw-bold"
                          style={{ color: "var(--color-text-primary)" }}
                        >
                          {item.titulo}
                        </span>
                        <span className="d-block small text-muted">
                          {item.descripcion}
                        </span>
                      </span>

                      <span
                        className="btn btn-sm rounded-pill px-3 d-none d-sm-inline-flex align-items-center gap-2"
                        style={{
                          backgroundColor: item.deshabilitado
                            ? "var(--color-border)"
                            : "var(--azul-logo-claro)",
                          color: item.deshabilitado
                            ? "var(--texto-gris-oscuro)"
                            : "white",
                        }}
                      >
                        {item.textoBoton}
                        <i
                          className={`bi ${item.deshabilitado ? "bi-clock" : "bi-arrow-right"}`}
                        />
                      </span>

                      <i
                        className={`bi ${item.deshabilitado ? "bi-clock" : "bi-chevron-right"} d-sm-none`}
                        style={{
                          color: item.deshabilitado
                            ? "var(--texto-gris-oscuro)"
                            : "var(--azul-logo-claro)",
                        }}
                      />
                    </>
                  );

                  const claseLink =
                    "text-decoration-none bg-white rounded-4 shadow-sm border d-flex align-items-center gap-3 p-3 p-md-4";

                  if (item.deshabilitado) {
                    return (
                      <div
                        key={item.titulo}
                        className={`${claseLink} opacity-75`}
                        role="button"
                        aria-disabled="true"
                        style={{ cursor: "not-allowed" }}
                      >
                        {contenido}
                      </div>
                    );
                  }

                  if (item.externo) {
                    return (
                      <a
                        key={item.titulo}
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                        className={claseLink}
                        onClick={() => { if (item.plataforma) { pixelClickDescargaApp({ plataforma: item.plataforma }); gtagClickDescargaApp({ plataforma: item.plataforma }); ttqClickDescargaApp({ plataforma: item.plataforma }); eventoClickDescargaApp({ plataforma: item.plataforma, usuarioId: usuario?.idUsuario }); } }}
                      >
                        {contenido}
                      </a>
                    );
                  }

                  return (
                    <Link key={item.titulo} to={item.url} className={claseLink}>
                      {contenido}
                    </Link>
                  );
                })}
              </div>

              <div className="card border-0 shadow-sm rounded-4 p-4 mt-2">
                <p className="fw-bold text-center mb-3" style={{ color: "var(--color-text-primary)" }}>Síguenos</p>
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  {[
                    { href: "https://www.instagram.com/zervicy",               icono: "bi-instagram",     label: "Instagram" },
                    { href: "https://www.facebook.com/zervicy/",               icono: "bi-facebook",      label: "Facebook" },
                    { href: "https://www.tiktok.com/@zervicy",                 icono: "bi-tiktok",        label: "TikTok" },
                    { href: "https://wa.me/573189859423?text=Hola%2C%20necesito%20ayuda%20con%20Zervicy", icono: "bi-whatsapp", label: "WhatsApp" },
                    { href: "mailto:info@zervicy.com",                         icono: "bi-envelope-fill", label: "Correo" },
                    { href: "https://www.youtube.com/@zervicy",                icono: "bi-youtube",       label: "YouTube" },
                  ].map((red) => (
                    <a
                      key={red.label}
                      href={red.href}
                      target={red.href.startsWith("mailto") ? undefined : "_blank"}
                      rel="noreferrer"
                      aria-label={red.label}
                      className="d-flex flex-column align-items-center gap-1 text-decoration-none"
                      style={{ color: "var(--azul-logo-claro)" }}
                    >
                      <span
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: 46, height: 46, backgroundColor: "rgba(var(--azul-logo-claro-rgb), .10)" }}
                      >
                        <i className={`bi ${red.icono} fs-5`} />
                      </span>
                      <span className="small text-muted">{red.label}</span>
                    </a>
                  ))}
                </div>
              </div>

              <div className="text-center mt-4">
                <p className="small text-muted mb-0">
                  Gracias por visitar Zervicy. Guarda este enlace para tener
                  siempre a la mano nuestros accesos oficiales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Links;
